import pkg from '../../package.json';

export const environment = {
    production: false,
    appName: 'Fina - Dev',
    apiUrl: 'https://fina-api.onrender.com/api',
    secret_key: 'finasupersecretkey',
    googleClientId: '166095284121-0nrhmps82e7oisckf4su291qvf3vas2r.apps.googleusercontent.com',
    unsplashAccessKey: 'KhR70UgIyNDpqilbSgMqD01Mbzqtzw0ZdjijI1UOr6A',
    version: pkg.version,
};

